import { StyledInputCustom } from 'components/UIComponents/FormStyles'
import React from 'react'
import { Chart, ChartElement, Level, Marks, SubChart } from './Styles'

const ScoreChart = ({
  tenthValue,
  twelfthValue,
  ugMarksValue,
  pgMarksValue,
  setScoreValue,
  isFieldsMandatory,
  setScoreError,
  scoreType,
  setMarksValue,
  marksValue,
  selectedCourses,
  setRoleFormData,
  roleFormData,
  eligibleCandidatesMetrics,
  marksValidator,
  disabled,
}) => {
  return (
    <Chart>
      <SubChart>
        <ChartElement borderLast={true}>
          <Level>
            10<sub>TH</sub>
          </Level>
          -{' '}
          <Marks>
            {' '}
            <StyledInputCustom
              width={'100%'}
              type="number"
              suffix={'%'}
              value={tenthValue}
              onKeyPress={e =>
                [' ', '.']?.includes(e.key) && e.preventDefault()
              }
              onChange={({ target }) => {
                const value = Number(target.value)

                const isValidNumber = /^(\d+)?(\.\d{0,2})?$/.test(value)
                if (!isNaN(value) && value % 1 !== 0) {
                  const roundedValue = value.toFixed(2)

                  if (scoreType == 'Average') {
                    let data = {
                      ...roleFormData,
                      scores: {
                        ...roleFormData?.scores,
                        avg: roundedValue,
                        tenth: roundedValue,
                        twelfth: roundedValue,
                        UG: roundedValue,
                        PG: roundedValue,
                        UGDiploma: roundedValue,
                      },
                    }
                    setRoleFormData({
                      ...data,
                    })
                    eligibleCandidatesMetrics(data)
                    let checking = {
                      tenthValue: roundedValue,
                      twelfthValue: roundedValue,
                      ugMarksValue: roundedValue,
                      pgMarksValue: roundedValue,
                      UGDiploma: roundedValue,
                    }
                    marksValidator(checking)
                  } else {
                    let data = {
                      ...roleFormData,
                      scores: {
                        ...roleFormData?.scores,
                        tenth: roundedValue,
                      },
                    }
                    setRoleFormData({
                      ...data,
                    })
                    eligibleCandidatesMetrics(data)
                  }
                } else if (scoreType == 'Average') {
                  let data = {
                    ...roleFormData,
                    scores: {
                      ...roleFormData?.scores,
                      avg: value,
                      tenth: value,
                      twelfth: value,
                      UG: value,
                      PG: value,
                      UGDiploma: value,
                    },
                  }
                  setRoleFormData({
                    ...data,
                  })
                  eligibleCandidatesMetrics(data)
                } else {
                  let data = {
                    ...roleFormData,
                    scores: {
                      ...roleFormData?.scores,
                      tenth: value,
                    },
                  }
                  setRoleFormData({
                    ...data,
                  })
                  eligibleCandidatesMetrics(data)
                }

                if (value >= 0 && value <= 100) {
                  if (!isValidNumber) {
                    setScoreError(
                      'Invalid input. Please enter a valid number with up to 2 decimal places.'
                    )
                  } else {
                    setScoreError('')
                  }
                } else {
                  setScoreError('The average score should be between 30 to 100')
                }
              }}
              placeholder="00"
              disabled={disabled}
            />
          </Marks>
        </ChartElement>
        <ChartElement borderLast={selectedCourses?.length > 0}>
          <Level>
            12<sub>TH</sub>
          </Level>
          -{' '}
          <Marks>
            <StyledInputCustom
              width={'100%'}
              type="number"
              suffix={'%'}
              onKeyPress={e =>
                [' ', '.']?.includes(e.key) && e.preventDefault()
              }
              value={twelfthValue}
              onChange={({ target }) => {
                const value = Number(target.value)
                const isValidNumber = /^(\d+)?(\.\d{0,2})?$/.test(value)
                if (!isNaN(value) && value % 1 !== 0) {
                  const roundedValue = value.toFixed(2)
                  if (scoreType == 'Average') {
                    let data = {
                      ...roleFormData,
                      scores: {
                        ...roleFormData?.scores,
                        avg: roundedValue,
                        tenth: roundedValue,
                        twelfth: roundedValue,
                        UG: roundedValue,
                        PG: roundedValue,
                        UGDiploma: roundedValue,
                      },
                    }
                    setRoleFormData({
                      ...data,
                    })
                    eligibleCandidatesMetrics(data)
                  } else {
                    let data = {
                      ...roleFormData,
                      scores: {
                        ...roleFormData?.scores,
                        twelfth: roundedValue,
                      },
                    }
                    setRoleFormData({
                      ...data,
                    })
                    eligibleCandidatesMetrics(data)
                  }
                } else if (scoreType == 'Average') {
                  let data = {
                    ...roleFormData,
                    scores: {
                      ...roleFormData?.scores,
                      avg: value,
                      tenth: value,
                      twelfth: value,
                      UG: value,
                      PG: value,
                      UGDiploma: value,
                    },
                  }
                  setRoleFormData({
                    ...data,
                  })
                  eligibleCandidatesMetrics(data)
                } else {
                  let data = {
                    ...roleFormData,
                    scores: {
                      ...roleFormData?.scores,
                      twelfth: value,
                    },
                  }
                  setRoleFormData({
                    ...data,
                  })
                  eligibleCandidatesMetrics(data)
                }

                if (value >= 0 && value <= 100) {
                  if (!isValidNumber) {
                    setScoreError(
                      'Invalid input. Please enter a valid number with up to 2 decimal places.'
                    )
                  } else {
                    setScoreError('')
                  }
                } else {
                  setScoreError('The average score should be between 30 to 100')
                }
              }}
              placeholder="00"
              disabled={disabled}
            />
          </Marks>
        </ChartElement>
        {selectedCourses?.map((item, index) => {
          const fieldName =
            item === 'UG'
              ? 'UG'
              : item === 'PG'
              ? 'PG'
              : item == 'DIPLOMA'
              ? 'UGDiploma'
              : 'PGDiploma'
          return (
            <ChartElement
              key={index + 'chartElement'}
              borderLast={selectedCourses?.length - 1 !== index}
            >
              <Level>{item}</Level>-{' '}
              <Marks>
                <StyledInputCustom
                  width={'100%'}
                  type="number"
                  suffix={'%'}
                  value={roleFormData?.scores[fieldName]}
                  onKeyPress={e =>
                    [' ', '.']?.includes(e.key) && e.preventDefault()
                  }
                  onChange={({ target }) => {
                    const value = Number(target.value)
                    const isValidNumber = /^(\d+)?(\.\d{0,2})?$/.test(value)
                    if (!isNaN(value) && value % 1 !== 0) {
                      const roundedValue = value.toFixed(2)
                      if (scoreType == 'Average') {
                        let data = {
                          ...roleFormData,
                          scores: {
                            ...roleFormData?.scores,
                            avg: roundedValue,
                            tenth: roundedValue,
                            twelfth: roundedValue,
                            UG: roundedValue,
                            PG: roundedValue,
                            UGDiploma: roundedValue,
                          },
                        }
                        setRoleFormData({
                          ...data,
                        })
                        eligibleCandidatesMetrics(data)
                      } else {
                        let data = {
                          ...roleFormData,
                          scores: {
                            ...roleFormData?.scores,
                            [fieldName]: roundedValue,
                          },
                        }
                        setRoleFormData({
                          ...data,
                        })
                        eligibleCandidatesMetrics(data)
                      }
                    } else if (scoreType == 'Average') {
                      let data = {
                        ...roleFormData,
                        scores: {
                          ...roleFormData?.scores,
                          avg: value,
                          tenth: value,
                          twelfth: value,
                          UG: value,
                          PG: value,
                          UGDiploma: value,
                        },
                      }
                      setRoleFormData({
                        ...data,
                      })
                      eligibleCandidatesMetrics(data)
                    } else {
                      let data = {
                        ...roleFormData,
                        scores: {
                          ...roleFormData?.scores,
                          [fieldName]: value,
                        },
                      }
                      setRoleFormData({
                        ...data,
                      })
                      eligibleCandidatesMetrics(data)
                    }

                    if (value >= 0 && value <= 100) {
                      if (!isValidNumber) {
                        setScoreError(
                          'Invalid input. Please enter a valid number with up to 2 decimal places.'
                        )
                      } else {
                        setScoreError('')
                      }
                    } else {
                      setScoreError(
                        'The average score should be between 30 to 100'
                      )
                    }
                  }}
                  placeholder="00"
                  disabled={disabled}
                />
              </Marks>
            </ChartElement>
          )
        })}
      </SubChart>
    </Chart>
  )
}

export default ScoreChart
